// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AgencieSelected_container__TMilG {
  animation: AgencieSelected_init__bsvQS 0.5s;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.AgencieSelected_container__TMilG .AgencieSelected_header__r2IlL {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
  margin-bottom: 30px;
}

.AgencieSelected_container__TMilG .AgencieSelected_navigator__Gt7dW {
  width: 5%;
  height: 100%;
  display: flex;
  align-items: center;
}

.AgencieSelected_container__TMilG .AgencieSelected_header__r2IlL .AgencieSelected_title__7q3Sf {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.AgencieSelected_container__TMilG .AgencieSelected_header__r2IlL .AgencieSelected_title__7q3Sf p,
span {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.AgencieSelected_container__TMilG .AgencieSelected_header__r2IlL .AgencieSelected_title__7q3Sf p {
  font-size: 1.3rem;
  margin-left: 10px;
  padding: 5px;
  border-radius: 10px;
  box-shadow: -5px 5px 15px -3px rgba(0, 0, 0, 0.111);
}

.AgencieSelected_tableContainer__m7JZt {
  width: 90%;
}

.AgencieSelected_tableContainer__m7JZt .AgencieSelected_table__l5p08 {
  margin-top: 10px;
  width: 100%;
  border-radius: 20px 20px 15px 15px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.112);
}

.AgencieSelected_modalDiv__8qTKn {
  width: 90%;
  height: 100%;
  display: flex;
  align-items: center;
}

.AgencieSelected_modalDiv__8qTKn h1 {
  width: 100%;
  font-family: Roboto, sans-serif;
  font-size: 1.3rem;
  font-weight: 300;
  text-align: center;
}

.AgencieSelected_addUserContainer__zaq2V {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
}

.AgencieSelected_emailAddUser__O\\+ven {
  margin-top: 10px;
  font-size: 1.4rem;
  font-weight: 400;
}

.AgencieSelected_nameAddUser__ONdUO {
  margin-top: 30px;
  font-size: 1.2rem;
}

.AgencieSelected_end__kFpFF {
  margin-top: 50px;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: center;
}

@keyframes AgencieSelected_init__bsvQS {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Concentrators/AgencieSelected/AgencieSelected.module.css"],"names":[],"mappings":"AAAA;EACE,2CAAoB;EACpB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 70px;\n  margin-bottom: 30px;\n}\n\n.container .navigator {\n  width: 5%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.container .header .title {\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .title p,\nspan {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .header .title p {\n  font-size: 1.3rem;\n  margin-left: 10px;\n  padding: 5px;\n  border-radius: 10px;\n  box-shadow: -5px 5px 15px -3px rgba(0, 0, 0, 0.111);\n}\n\n.tableContainer {\n  width: 90%;\n}\n\n.tableContainer .table {\n  margin-top: 10px;\n  width: 100%;\n  border-radius: 20px 20px 15px 15px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.112);\n}\n\n.modalDiv {\n  width: 90%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.modalDiv h1 {\n  width: 100%;\n  font-family: Roboto, sans-serif;\n  font-size: 1.3rem;\n  font-weight: 300;\n  text-align: center;\n}\n\n.addUserContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  font-weight: 700;\n}\n\n.emailAddUser {\n  margin-top: 10px;\n  font-size: 1.4rem;\n  font-weight: 400;\n}\n\n.nameAddUser {\n  margin-top: 30px;\n  font-size: 1.2rem;\n}\n\n.end {\n  margin-top: 50px;\n  width: 100%;\n  height: 100px;\n  display: flex;\n  justify-content: center;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AgencieSelected_container__TMilG`,
	"init": `AgencieSelected_init__bsvQS`,
	"header": `AgencieSelected_header__r2IlL`,
	"navigator": `AgencieSelected_navigator__Gt7dW`,
	"title": `AgencieSelected_title__7q3Sf`,
	"tableContainer": `AgencieSelected_tableContainer__m7JZt`,
	"table": `AgencieSelected_table__l5p08`,
	"modalDiv": `AgencieSelected_modalDiv__8qTKn`,
	"addUserContainer": `AgencieSelected_addUserContainer__zaq2V`,
	"emailAddUser": `AgencieSelected_emailAddUser__O+ven`,
	"nameAddUser": `AgencieSelected_nameAddUser__ONdUO`,
	"end": `AgencieSelected_end__kFpFF`
};
export default ___CSS_LOADER_EXPORT___;
